import { Button, Card, Modal } from "react-bootstrap";
import { useTranslation } from 'react-i18next';

const CleaningServicesModal = (props) => {
  const { t } = useTranslation();
  const title = t('cleaningModalTitle');

  return (
    <Modal
      {...props}
      size="lg"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title className="h1">
          {title}{t('cleaningModalSuffix')}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{t('cleaningModalDesc')}</p>
        <Card className="px-4">
          <ul>
            <li>{t('cleaningService1')}</li>
            <li>{t('cleaningService2')}</li>
            <li>{t('cleaningService3')}</li>
          </ul>
        </Card>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={() => props.onHide(title)}>{t('getQuote')}</Button>
      </Modal.Footer>
    </Modal>
  );
}

export default CleaningServicesModal;
